import { AxiosInstance } from 'axios';
import { createContext } from 'react';

const CCAxiosContext = createContext<AxiosInstance>({} as AxiosInstance);
export default CCAxiosContext;
